/**
 * Created by TzuHsing on 2020-10-15
 */
import React, { Component } from 'react'
import {
  Input,
  message,
  Modal,
  Table,
  Button,
  Checkbox,
  Switch,
  TimePicker,
} from 'antd'
import { DISABLE, ENABLE } from '../constants'
import './style.css'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import * as actions from '../action'
import NewPackageModal from './newPackageModal'
import moment from 'moment'
const CheckboxGroup = Checkbox.Group
class PackageDetail extends Component {
  state = {
    isLoading: false,
    typingPackageName: '',
    typingPackagePrice: '',
    typingPackageTime: '',
    allowTable: [],
    disallowTable: [],
    isTyped: false,
    plainOptions: [
      { label: '周一', value: 1, disabled: false, postData: '1' },
      { label: '周二', value: 2, disabled: false, postData: '1' },
      { label: '周三', value: 3, disabled: false, postData: '1' },
      { label: '周四', value: 4, disabled: false, postData: '1' },
      { label: '周五', value: 5, disabled: false, postData: '1' },
      { label: '周六', value: 6, disabled: false, postData: '1' },
      { label: '周日', value: 7, disabled: false, postData: '1' },
    ],
    checkedList: [1, 2, 3, 4, 5, 6, 7],
    startTime: new Date(),
    endTiem: new Date(),
    purchaseStartTime: '00:00:00', // 新增限时开始时间
    purchaseEndTime: '00:00:00', // 新增限时结束时间
    purchaseWeekday: ['1', '1', '1', '1', '1', '1', '1'], // 新增选择日期
    isPurchaseLimitEnabled: true,

    visible: false,
    chosenId: '',
  }

  componentDidMount() {
    const sd = new Date()
    sd.setHours(0, 0)
    this.setState({
      startTime: sd,
      endTiem: sd,
    })
    this.updateState()
  }

  updateState = () => {
    const {
      name,
      duration,
      amount,
      id,
      purchaseEndTime,
      purchaseStartTime,
      purchaseWeekday,
      isPurchaseLimitEnabled,
    } = this.props.editRecord
    const sd = new Date()
    const ed = new Date()
    sd.setHours(
      purchaseStartTime.split(':')[0],
      purchaseStartTime.split(':')[1]
    )
    ed.setHours(purchaseEndTime.split(':')[0], purchaseEndTime.split(':')[1])
    /*
      十进制转二进制再转成数组形式再反转数组如： 127 -> 1111111 -> [1,1,1,1,1,1,1,1]
                                              127 -> 此处是7~1 -> 变成1~7
    */
    const pwd = purchaseWeekday.toString(2).split('').reverse()
    const lData = [...this.state.plainOptions]
    for (let index = 0; index < pwd.length; index++) {
      const nItem = pwd[index]
      const lItem = lData[index]
      lItem.postData = nItem
    }
    this.setState(
      {
        isLoading: true,
        typingPackageName: name,
        typingPackagePrice: amount / 100,
        typingPackageTime: duration / 60,
        purchaseStartTime,
        purchaseEndTime,
        plainOptions: lData,
        isPurchaseLimitEnabled,
        startTime: sd,
        endTiem: ed,
      },
      async () => {
        console.log(this.state.plainOptions)
        const checkedList = []
        for (let index = 0; index < pwd.length; index++) {
          const lItem = this.state.plainOptions[index]
          if (lItem.postData == '1') {
            checkedList.push(lItem.value)
          }
        }
        this.onChange(checkedList)
        this.props.fetchCurrentTableByPackage(
          {
            prepaid_ids: [id],
          },
          (isSuccess, res) => {
            if (isSuccess) {
              const tableList = this.props.clubTable
              const enableArr = res.data.map((item) => item.tableId + '')
              const unableArr = []
              tableList.forEach((item) => {
                if (!enableArr.includes(item.table_id)) {
                  unableArr.push(item.table_id)
                }
              })
              if (Array.isArray(enableArr) && Array.isArray(unableArr)) {
                this.setState({
                  allowTable: enableArr,
                  disallowTable: unableArr,
                  isLoading: false,
                })
              }
            } else {
              message.error(res ? res.detail : '请求失败')
              this.setState({ isLoading: false })
            }
          }
        )
      }
    )
  }

  handleOk = async () => {
    this.handleBindTable()

    // const {
    //   typingPackageName,
    //   typingPackagePrice,
    //   typingPackageTime,
    //   purchaseStartTime,
    //   purchaseEndTime,
    //   purchaseWeekday,
    //   isPurchaseLimitEnabled,
    // } = this.state
    // console.log(purchaseWeekday)
    // if (this.state.isTyped) {
    //   this.setState({ isLoading: true }, () => {
    //     let data = {
    //       id: this.props.editRecord.id,
    //       name: typingPackageName,
    //       amount: +typingPackagePrice * 100,
    //       duration: +typingPackageTime * 60,
    //       is_enabled: ENABLE,
    //       isPurchaseLimitEnabled: isPurchaseLimitEnabled ? 1 : 0,
    //     }
    //     if (isPurchaseLimitEnabled) {
    //       data = {
    //         ...data,
    //         purchaseStartTime,
    //         purchaseEndTime,
    //         purchaseWeekday: parseInt(purchaseWeekday.reverse().join(''), 2),
    //       }
    //     }
    //     this.props.fetchEditPackage(data, (isSuccess, res) => {
    //       console.log('res', res)
    //       if (isSuccess) {
    //         this.setState({ isLoading: false }, () =>
    //           this.handleBindTable(res.data)
    //         )
    //       } else {
    //         this.setState({ isLoading: false }, this.props.onCancel)
    //       }
    //     })
    //   })
    // } else {
    //   this.handleBindTable()
    // }
  }

  handleBindTable = (newId) => {
    this.setState({ isLoading: true })
    const { allowTable, disallowTable } = this.state
    if (allowTable.length > 0) {
      this.requestSave(newId, allowTable, ENABLE)
    } else {
      this.requestSave(newId, disallowTable, DISABLE)
    }
  }

  requestSave(newId, tableArray, enabled) {
    this.setState({ isLoading: true })
    const id = newId ? newId : [this.props.editRecord.id]
    this.props.fetchPackageToTables(
      {
        prepaid_ids: id,
        table_ids: tableArray,
        is_enabled: enabled,
      },
      (isSuccess) => {
        this.setState({ isLoading: false }, this.props.onCancel)
      }
    )
  }

  async handleDelete(callback) {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        this.props.fetchEditPackage(
          {
            id: this.props.editRecord.id,
            is_enabled: DISABLE,
          },
          (isSuccess) => {
            if (isSuccess) {
              this.setState({ isLoading: false }, callback)
            } else {
              this.setState({ isLoading: false })
            }
          }
        )
      }
    )
  }

  setTypingInfo = (typingAttr, value) => {
    this.setState(() => ({ [typingAttr]: value, isTyped: true }))
  }

  setTypingSwitch = (typingAttr, value) => {
    this.setState((preState) => ({ [typingAttr]: !preState[typingAttr] }))
  }

  handleSwitchTable(isAllow, tableId) {
    const { allowTable, disallowTable } = this.state
    if (isAllow) {
      const idx = allowTable.indexOf(tableId)
      const newAllowTable = [...allowTable]
      newAllowTable.splice(idx, 1)
      this.setState({
        allowTable: newAllowTable,
        disallowTable: [...disallowTable, tableId],
      })
    } else {
      const idx = disallowTable.indexOf(tableId)
      const newDisallowTable = [...disallowTable]
      newDisallowTable.splice(idx, 1)
      this.setState({
        allowTable: [...allowTable, tableId],
        disallowTable: newDisallowTable,
      })
    }
  }

  returnCurrentColumns(isAllow) {
    return [
      {
        title: '球台名',
        dataIndex: 'name',
        key: 'name',
        width: '60%',
        align: 'center',
      },
      {
        title: '操作',
        key: 'action',
        width: '40%',
        align: 'center',
        render: (text, record) => (
          <div onClick={() => this.handleSwitchTable(isAllow, record.table_id)}>
            {isAllow ? (
              <Button type="primary" danger>
                关闭
              </Button>
            ) : (
              <Button type="primary">启用</Button>
            )}
          </div>
        ),
      },
    ]
  }

  returnDataSource(isAllow) {
    const { allowTable, disallowTable } = this.state
    if (isAllow) {
      return this.props.clubTable.filter((item) => {
        return allowTable.includes(item.table_id)
      })
    } else {
      return this.props.clubTable.filter((item) => {
        return disallowTable.includes(item.table_id)
      })
    }
  }

  onChange = (list) => {
    console.log(list)
    const weeks = []
    const newOptions = this.state.plainOptions.map((item) => {
      if (list.includes(item.value)) {
        item.postData = '1'
        if (list.length == 1) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      } else {
        item.postData = '0'
      }
      weeks.push(item.postData)
      return item
    })
    this.setState((preState) => ({
      checkedList: list.length > 0 ? list : preState.checkedList,
      plainOptions: newOptions,
    }))
    this.setTypingInfo('purchaseWeekday', weeks)
  }

  timeSOnChange = (value, dateString) => {
    if (value) {
      this.setTypingInfo('purchaseStartTime', dateString)
      this.setState({
        startTime: value,
      })
    }
  }

  timeEOnChange = (value, dateString) => {
    if (value) {
      this.setTypingInfo('purchaseEndTime', dateString)
      this.setState({
        endTiem: value,
      })
    }
  }

  // 关闭套餐详情模态窗
  handleCancel = () => {
    this.setState({
      visible: false,
    })
  }

  render() {
    const { isShowPackageDetail, record } = this.props
    const {
      isLoading,
      typingPackageName,
      typingPackagePrice,
      typingPackageTime,
      plainOptions,
      checkedList,
      isPurchaseLimitEnabled,
      startTime,
      endTiem,
    } = this.state
    const columns1 = this.returnCurrentColumns(true)
    const columns2 = this.returnCurrentColumns(false)
    const dataSource1 = this.returnDataSource(true)
    const dataSource2 = this.returnDataSource(false)
    return (
      <div>
        <Modal
          title={record.name}
          visible={isShowPackageDetail}
          okText="保存修改"
          cancelText="删除"
          className="PackageDetail"
          onCancel={this.props.onCancel}
          confirmLoading={isLoading}
          width="80vw"
          footer={
            <div className="detail-button displayFlexRow">
              {/* <Button
                type="primary"
                danger
                loading={isLoading}
                disabled={isLoading}
                onClick={async () => {
                  await this.handleDelete(() => {
                    this.props.onCancel()
                  })
                }}
              >
                删除套餐
              </Button> */}
              <Button
                type="primary"
                loading={isLoading}
                disabled={isLoading}
                onClick={async () => {
                  await this.handleOk()
                }}
              >
                保存修改
              </Button>
            </div>
          }
        >
          <div className="detail-inputBox">
            {/* <Button
              type="primary"
              onClick={() => {
                this.setState({
                  visible: true,
                  chosenId: this.props.editRecord.id,
                })
              }}
            >
              套餐详情
            </Button> */}
            {/* <div className="displayFlexRow detail-inputBox-item">
              <div className="inputLabel">套餐名</div>
              <Input
                onChange={(e) => {
                  this.setTypingInfo('typingPackageName', e.target.value)
                }}
                value={typingPackageName}
              />
            </div>
            <div className="displayFlexRow detail-inputBox-item">
              <div className="inputLabel">价格（元）</div>
              <Input
                onChange={(e) => {
                  const newText = e.target.value
                  const isAllowText = /^\d+(\.\d{0,2})?$/.test(newText)
                  ;(isAllowText || newText === '') &&
                    this.setTypingInfo('typingPackagePrice', e.target.value)
                }}
                value={typingPackagePrice}
              />
            </div>
            <div className="displayFlexRow detail-inputBox-item">
              <div className="inputLabel">时长（分钟）</div>
              <Input
                onChange={(e) => {
                  const newText = e.target.value
                  const isAllowText = /^\d+(\.\d{0,2})?$/.test(newText)
                  ;(isAllowText || newText === '') &&
                    this.setTypingInfo('typingPackageTime', e.target.value)
                }}
                value={typingPackageTime}
              />
            </div>
            <div className="displayFlexRow detail-inputBox-item">
              <div className="inputLabel">
                限时购买
                <div style={{ marginLeft: '10px', display: 'inline' }}>
                  <Switch
                    style={{}}
                    onChange={() => {
                      this.setTypingSwitch('isPurchaseLimitEnabled')
                    }}
                    checked={isPurchaseLimitEnabled}
                  />
                </div>
              </div>
              {isPurchaseLimitEnabled && (
                <div className="add-package-box-date-view" style={{ flex: 1 }}>
                  <span className="date-tip-text">限时购买使用</span>
                  <TimePicker
                    id="stime"
                    format="HH:mm"
                    placeholder="开始时间"
                    value={moment(startTime)}
                    onChange={this.timeSOnChange}
                  />
                  <TimePicker
                    id="etime"
                    format="HH:mm"
                    placeholder="结束时间"
                    value={moment(endTiem)}
                    onChange={this.timeEOnChange}
                  />
                  <div className="add-package-box-check-box">
                    <CheckboxGroup
                      options={plainOptions}
                      value={checkedList}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
              )}
            </div> */}
          </div>
          <div className="handleList-box">
            <div className="enablePackage">
              <h3 style={{ marginTop: '0.5em' }}>正在启用该套餐的球台</h3>
              <Table
                rowKey="table_id"
                bordered
                columns={columns1}
                loading={isLoading}
                dataSource={dataSource1}
                pagination={{ pageSize: 9 }}
              />
            </div>
            <div className="unablePackage">
              <h3 style={{ marginTop: '0.5em' }}>未启用该套餐的球台</h3>
              <Table
                rowKey="table_id"
                bordered
                columns={columns2}
                loading={isLoading}
                dataSource={dataSource2}
                pagination={{ pageSize: 9 }}
              />
            </div>
          </div>
        </Modal>

        {this.state.visible && (
          <NewPackageModal
            visible={this.state.visible}
            handleCancelPackage={this.handleCancel}
            id={this.state.chosenId}
          ></NewPackageModal>
        )}
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    editRecord: state.getClubTable.editRecord,
  }
}
export default withRouter(connect(mapStateToProps, actions)(PackageDetail))



// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/PackageDetail.js